export const SUPPORT_EMAIL = {
  VIP: 'vipsupport@splashsports.com',
  DEFAULT: 'support@splashsports.com',
} as const;
